import React from 'react';
//import useStyles from './Styles';
import loading from './loading.svg';
import "./Loading.scss";

interface Props {
	isLoading:boolean,
}

const Loading:React.FC<Props> = (props)=> {
	if(!props.isLoading){
		return (null);
	}
	//const classes = useStyles();
	return (
		<div id="loading" className="loading">
			<span className="spinner"><img src={loading} alt="just a minute..."/></span>
		</div>
    );
}

export default Loading;
